import React, { useCallback, useState, useRef, useEffect } from 'react';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../dynamicFormBuilder/FormField';
import { GridLayout } from "../../../../common/GridLayout";
import { FillFilters } from '../../../../common/Utils';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import axios from "axios";
import { confirm } from 'devextreme/ui/dialog';
import DropDownButton from 'devextreme-react/drop-down-button';
import { useHistory, Link } from 'react-router-dom';
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
} from "devextreme-react/data-grid";
import { SearchLayout } from './Layout';
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
import SignatureCapture from '../dataentry/headerOperations/captureSignature/SignatureCapture';
import ShowSignature from '../dataentry/headerOperations/showSignature/ShowSignature';
import notify from 'devextreme/ui/notify';
import '../../../../common/css/searchPage.css';

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];

const getActionItems = (hasSelection) => [
    { id: 'newTransaction', name: 'Enter New Transaction' },
    { id: 'editTransaction', name: 'Edit Current Transaction', disabled: !hasSelection },
    { id: 'captureSignature', name: 'Capture Signature', disabled: !hasSelection },
    { id: 'showSignature', name: 'Show Signature', disabled: !hasSelection }
];

const List = (props) => {
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const history = useHistory();
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const [selectedItems, setSelectedItems] = useState([]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(false);
    const dataGrid = useRef(null);

    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "AD9BE043-9463-4197-8393-4F24A206CBFC";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const initialFormFields = {
        DeliveryPickupPlannedDateTime: null,
        RPlanWarehouse: null,
        TransactionType: null,
        StatusFilter: null,
        SchedStatus: null,
        Customer: null,
        CustomerName: null,
        TransactionNumber: null,
        Container: null,
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const formFieldsRef = useRef(formFields);

    // Keep ref in sync with state
    useEffect(() => {
        formFieldsRef.current = formFields;
    }, [formFields]);

    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );

    // Fields that are passed as loadParams (not as DevExtreme grid filters)
    const loadParamFields = ['RPlanWarehouse', 'TransactionType', 'StatusFilter', 'SchedStatus', 'Customer', 'CustomerName', 'TransactionNumber', 'Container'];

    const handleSearch = (e) => {
        e.event.stopPropagation();
        let datasource = loadDatasource();

        // Exclude loadParam fields from FillFilters so DevExtreme doesn't try to resolve them on the DTO
        const filterableFields = Object.fromEntries(
            Object.entries(formFields).filter(([key]) => !loadParamFields.includes(key))
        );
        const filters = FillFilters(filterableFields);

        if (formFields.Customer) {
            const customerFilter = ["IdentityId", "contains", formFields.Customer];
            if (filters.length > 0) {
                filters.push("and", customerFilter);
            } else {
                filters.push(...customerFilter);
            }
        }

        if (formFields.CustomerName) {
            const customerNameFilter = ["CustomerName", "contains", formFields.CustomerName];
            if (filters.length > 0) {
                filters.push("and", customerNameFilter);
            } else {
                filters.push(...customerNameFilter);
            }
        }

        if (formFields.TransactionNumber) {
            const transactionNumberFilter = ["TransactionNumber", "contains", formFields.TransactionNumber];
            if (filters.length > 0) {
                filters.push("and", transactionNumberFilter);
            } else {
                filters.push(...transactionNumberFilter);
            }
        }

        if (formFields.Container) {
            const containerFilter = ["Container", "contains", formFields.Container];
            if (filters.length > 0) {
                filters.push("and", containerFilter);
            } else {
                filters.push(...containerFilter);
            }
        }

        if (filters.length === 0) {
            datasource.filter(null);
        }

        datasource.filter(filters);
        setResultData(datasource);
    };

    const handleReset = (e) => {
        e.event.stopPropagation();
        setformFields(initialFormFields);
        setTimeout(() => {
            setResultData(loadDatasource());
        }, 100);
    };

    const loadLookupFromDataSource = (name, dataSource) => {
        if (formRefs && formRefs.current && formRefs.current[name]) {
            const ref = formRefs.current[name];
            if (typeof ref.instance === 'function') {
                const instance = ref.instance();
                if (instance && typeof instance.option === 'function') {
                    instance.option('dataSource', dataSource);
                    instance.option('valueExpr', 'id');
                    instance.option('displayExpr', 'name');
                }
            }
        }
    };

    const handleFormLoad = useCallback(() => {
        var warehouseDataSource = new DataSource({
            store: new createStore({
                key: 'id',
                loadUrl: `${window._env_.REACT_APP_APIS}/id/Lookup/GetWarehouses`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });
        loadLookupFromDataSource("RPlanWarehouse", warehouseDataSource);

        const typeOptions = [
            { id: 'R', name: 'Receipt' },
            { id: 'S', name: 'Shipment' },
            { id: 'B', name: 'Both Shipment and Receipt' }
        ];
        loadLookupFromDataSource("TransactionType", typeOptions);

        const statusOptions = [
            { id: 'C', name: 'Committed Only' },
            { id: 'U', name: 'Uncommitted Only' },
            { id: 'B', name: 'Both Committed & Uncommitted' }
        ];
        loadLookupFromDataSource("StatusFilter", statusOptions);

        const schedStatusOptions = [
            { id: 'P', name: 'Plan From' },
            { id: 'Y', name: 'Yard Arrive' },
            { id: 'D', name: 'Dock Start' },
            { id: 'E', name: 'Dock End' },
            { id: 'N', name: 'No Shows' },
            { id: 'X', name: 'Not Completed' }
        ];
        loadLookupFromDataSource("SchedStatus", schedStatusOptions);
    }, [accessToken]);

    const handleFieldChange = useCallback((name, value) => {
        // Handle field changes if needed
    }, []);

    useEffect(() => {
        if (!resultData) {
            setResultData(loadDatasource());
        }
    }, []);

    const loadDatasource = () => {
        let store = createStore({
            key: 'RowId',
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.Transaction.GetTransactionSchedules}`,
            loadParams: {
                warehouse: function () {
                    return formFieldsRef.current.RPlanWarehouse || '';
                },
                transactionType: function () {
                    return formFieldsRef.current.TransactionType || '';
                },
                statusFilter: function () {
                    return formFieldsRef.current.StatusFilter || '';
                },
                schedStatus: function () {
                    return formFieldsRef.current.SchedStatus || '';
                }
            },
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        const dataSource = new DataSource({ store: store });
        return dataSource;
    };

    const [resultData, setResultData] = useState(null);
    const [hasSelection, setHasSelection] = useState(false);
    const [showSignatureCapturePopup, setShowSignatureCapturePopup] = useState(false);
    const [showSignaturePopup, setShowSignaturePopup] = useState(false);
    const [signatureRowId, setSignatureRowId] = useState(null);

    const onActionItemClick = useCallback((e) => {
        if (e.itemData?.id === 'newTransaction') {
            history.push('/wm/transactiondataentry/create-transaction');
        } else if (e.itemData?.id === 'editTransaction') {
            const gridInstance = dataGrid.current?.instance();
            if (!gridInstance) return;
            const selectedRows = gridInstance.getSelectedRowsData();
            if (!selectedRows || selectedRows.length === 0) return;
            const rowId = selectedRows[0].RowId;
            history.push(`/wm/transactiondataentry/edit-transaction?id=${rowId}`);
        } else if (e.itemData?.id === 'captureSignature') {
            const gridInstance = dataGrid.current?.instance();
            if (!gridInstance) return;
            const selectedRows = gridInstance.getSelectedRowsData();
            if (!selectedRows || selectedRows.length === 0) return;
            setSignatureRowId(selectedRows[0].RowId);
            setShowSignatureCapturePopup(true);
        } else if (e.itemData?.id === 'showSignature') {
            const gridInstance = dataGrid.current?.instance();
            if (!gridInstance) return;
            const selectedRows = gridInstance.getSelectedRowsData();
            if (!selectedRows || selectedRows.length === 0) return;
            setSignatureRowId(selectedRows[0].RowId);
            setShowSignaturePopup(true);
        }
    }, [history]);

    const handleDelete = useCallback(() => {
        const gridInstance = dataGrid.current?.instance();
        if (!gridInstance) return;
        const selectedRows = gridInstance.getSelectedRowsData();
        if (!selectedRows || selectedRows.length === 0) {
            return;
        }
        let result = confirm("<i>Are you sure you want to delete the selected transaction(s)?</i>", "Delete Confirmation");
        result.then(async (dialogResult) => {
            if (dialogResult) {
                try {
                    for (const row of selectedRows) {
                        await axios.post(
                            `${window._env_.REACT_APP_APIS}/wm/Transaction/DeleteTransaction`,
                            JSON.stringify(row.RowId),
                            {
                                headers: {
                                    'Content-Type': 'application/json',
                                    access_token: accessToken,
                                    Authorization: `Bearer ${accessToken}`,
                                },
                            }
                        );
                    }
                    gridInstance.refresh();
                } catch (e) {
                    console.error("Delete failed:", e);
                }
            }
        });
    }, [accessToken]);

    return (
        <div className="search-page-container">
            <div className="search-page-content">
                <div id="accordion" className="search-page-accordion">
                    <AccordionReact
                        dataSource={searchpanel}
                        collapsible={true}
                        multiple={false}
                        animationDuration={300}
                        selectedItems={selectedItems}
                        onSelectionChanged={e => {
                            if (e.currentTarget === e.target) {
                                selectionChanged(e, e.target);
                            }
                        }}
                        itemTitleRender={() => (
                            <Toolbar className="accordian-toolbar">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2
                                            }}
                                        >
                                            Enter Your Query For Schedules Management
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                            </Toolbar>
                        )}
                        itemRender={(itemProps) => (
                            <FormField
                                currrentUser={currentUser}
                                layoutId='05D1B77F-CA4F-4B16-800D-F5615978CD2D'
                                layoutName='WMSchedulesManagementSearchForm'
                                defaultFormSchema={SearchLayout}
                                formFields={formFields}
                                setformFields={setformFields}
                                handleFieldValueChange={handleFieldChange}
                                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                formRefs={formRefs}
                                onFormLoad={handleFormLoad}
                                noSpacingBeforeFirstRow={true}
                            />
                        )}
                        id="accordion-container" className="accordion-height"
                    />
                </div>
                <div className="search-page-grid-container">
                    <DataGrid
                        onExporting={(e) => {
                            if (window.handleDevExtremeDataGridExport) {
                                window.handleDevExtremeDataGridExport(e);
                            }
                        }}
                        ref={dataGrid}
                        allowColumnReordering={true}
                        allowColumnResizing={true}
                        dataSource={resultData}
                        showBorders={true}
                        hoverStateEnabled={true}
                        className="search-page-grid"
                        remoteOperations={true}
                        searchEnabled={true}
                        columnAutoWidth={true}
                        onSelectionChanged={(e) => {
                            setHasSelection(e.selectedRowsData && e.selectedRowsData.length > 0);
                        }}
                    >
                        <ColumnChooser
                            enabled={true}
                            title="Choose Column"
                            width={290}
                            height={290}
                            sortOrder="asc"
                        >
                            <ColumnChooserSearch
                                enabled={true}
                                editorOptions={{ placeholder: 'Search column' }} />
                        </ColumnChooser>
                        <Export enabled={true} allowExportSelectedData={true} />
                        <Selection mode="multiple" />
                        <Sorting visible={true} mode="multiple" />
                        <Paging defaultPageSize={10} />
                        <Pager
                            visible={true}
                            showPageSizeSelector={true}
                            allowedPageSizes={allowedPageSizes}
                            showNavigationButtons={true}
                        />
                        <FilterRow visible={true} />
                        <FilterPanel visible={true} />
                        <GroupPanel visible={true} />
                        <Grouping autoExpandAll={false} />
                        <StateStoring
                            enabled={true}
                            type="custom"
                            customLoad={loadState}
                            storageKey={gridKey}
                            customSave={saveState}
                        />
                        <GridToolbar>
                            <GridToolbarItem location="before">
                                <Button
                                    disabled={!hasSelection}
                                    onClick={() => {
                                        const gridInstance = dataGrid.current?.instance();
                                        if (!gridInstance) return;
                                        const selectedRows = gridInstance.getSelectedRowsData();
                                        if (!selectedRows || selectedRows.length === 0) return;
                                        history.push('/wm/schedulesmanagement/edit-schedule?id=' + selectedRows[0].RowId);
                                    }}
                                    type="default"
                                    text="Edit"
                                />
                            </GridToolbarItem>
                            <GridToolbarItem location="before">
                                <div>
                                    <Link to="/wm/schedulesmanagement/add-schedule">
                                        <Button
                                            type="default"
                                            className="gridTopButton"
                                            text="Create"
                                        />
                                    </Link>
                                </div>
                            </GridToolbarItem>
                            <GridToolbarItem location="after">
                                <Button text="Delete" icon="trash" type="default" onClick={handleDelete} disabled={!hasSelection} />
                            </GridToolbarItem>
                            <GridToolbarItem location="after">
                                <DropDownButton
                                    text="Options"
                                    icon="preferences"
                                    items={getActionItems(hasSelection)}
                                    onItemClick={onActionItemClick}
                                    displayExpr="name"
                                    keyExpr="id"
                                    dropDownOptions={{ width: 250 }}
                                />
                            </GridToolbarItem>
                            <GridToolbarItem location="after">
                                <GridLayoutManager
                                    gridKey={gridKey}
                                    gridRef={dataGrid}
                                    currentLayout={currentLayout}
                                    setCurrentLayout={setCurrentLayout}
                                    accessToken={accessToken}
                                />
                            </GridToolbarItem>
                            <GridToolbarItem name="columnChooserButton" />
                            <GridToolbarItem name="exportButton" />
                        </GridToolbar>

                        {/* ===== Visible Columns (Image 1) ===== */}
                        <Column dataType="string" caption="Record #" dataField="RecordNumber" />
                        <Column dataType="string" caption="Transaction #" dataField="TransactionNumber" />
                        <Column dataType="string" caption="Customer" dataField="IdentityId" />
                        <Column dataType="string" caption="Customer Name" dataField="CustomerName" />
                        <Column dataType="datetime" caption="Yard - Arrive" dataField="YardArriveTime" />
                        <Column dataType="datetime" caption="Yard Leave" dataField="TransportationYardLeaveDate" />
                        <Column dataType="datetime" caption="Staging End Dt" dataField="StagingEndDate" />
                        <Column dataType="string" caption="Delv Flag" dataField="DeliveryPickupFlag" />
                        <Column dataType="datetime" caption="Staging Planned Dt" dataField="PlannedReceivedShippedDateTime" />
                        <Column dataType="datetime" caption="Staging Start Dt" dataField="StagingStartDate" />
                        <Column dataType="datetime" caption="Plan From" dataField="DeliveryPickupPlannedDateTime" />
                        <Column dataType="datetime" caption="Plan From Time" dataField="PlanTime" />
                        <Column dataType="datetime" caption="Plan To" dataField="DeliveryPickupArriveDateTime" />
                        <Column dataType="datetime" caption="Plan To Time" dataField="PlanToTime" />
                        <Column dataType="string" caption="Type" dataField="TransactionType" />
                        <Column dataType="string" caption="Shipper's #" dataField="ShipperBolNumber" />
                        <Column dataType="string" caption="Status" dataField="Status" />
                        <Column dataType="datetime" caption="Trans Date" dataField="TransactionDate" />
                        <Column dataType="number" caption="Amount" dataField="FreightAmount" />
                        <Column dataType="string" caption="Trailer #/EIR" dataField="EquipmentInterchangeReport" />

                        {/* ===== Visible Columns (Image 2) ===== */}
                        <Column dataType="string" caption="PO/Reference" dataField="Reference" />
                        <Column dataType="string" caption="Mode" dataField="TransportationMode" />
                        <Column dataType="datetime" caption="Dock - Start" dataField="TruckArrivalDateTime" />
                        <Column dataType="string" caption="Dispatch #" dataField="DispatchOrderNumber" />
                        <Column dataType="string" caption="Freight Charge Type" dataField="FreightChargeType" />
                        <Column dataType="number" caption="COD Amount" dataField="CodAmount" />
                        <Column dataType="number" caption="Collected" dataField="CodAmountCollected" />
                        <Column dataType="datetime" caption="COD Date" dataField="CodCollectionDateTime" />
                        <Column dataType="string" caption="Pay Method" dataField="CodPayMethod" />
                        <Column dataType="string" caption="Tax Basis" dataField="TaxBasis" />
                        <Column dataType="number" caption="Tax Rate" dataField="TaxRate" />
                        <Column dataType="number" caption="Tax Amount" dataField="TaxAmount" />
                        <Column dataType="string" caption="Print Receipt" dataField="PrintReceipt" />
                        <Column dataType="string" caption="Print BOL" dataField="PrintBol" />
                        <Column dataType="string" caption="Print Label" dataField="PrintLabel" />
                        <Column dataType="string" caption="Send FAX" dataField="SendFax" />
                        <Column dataType="string" caption="Carrier" dataField="CarrierId" />
                        <Column dataType="string" caption="Carrier Name" dataField="CarrierName" />
                        <Column dataType="string" caption="Equipment" dataField="EquipmentId" />

                        {/* ===== Hidden Columns (from Column Chooser - Image 3) ===== */}
                        <Column dataType="string" caption="Consignee City" dataField="ConsigneeCity" visible={false} />
                        <Column dataType="string" caption="Consignee ID" dataField="ConsigneeId" visible={false} />
                        <Column dataType="string" caption="Consignee Name" dataField="ConsigneeName" visible={false} />
                        <Column dataType="string" caption="Consignee Phone" dataField="ConsigneeTelephone1" visible={false} />
                        <Column dataType="string" caption="Consignee State" dataField="ConsigneeState" visible={false} />
                        <Column dataType="string" caption="Consignee Zip" dataField="ConsigneeZip" visible={false} />
                        <Column dataType="string" caption="Consignee Address-1" dataField="ConsigneeAddress1" visible={false} />
                        <Column dataType="string" caption="Consignee Address-2" dataField="ConsigneeAddress2" visible={false} />
                        <Column dataType="string" caption="Consolidate" dataField="ConsolidateInvoiceFlag" visible={false} />
                        <Column dataType="string" caption="Container #" dataField="Container" visible={false} />
                        <Column dataType="string" caption="Created By" dataField="CreationUserId" visible={false} />
                        <Column dataType="datetime" caption="Creation Date" dataField="CreationDateTime" visible={false} />
                        <Column dataType="string" caption="Carrier Telephone 1" dataField="CarrierTelephone1" visible={false} />
                        <Column dataType="string" caption="Carrier Telephone 2" dataField="CarrierTelephone2" visible={false} />
                        <Column dataType="datetime" caption="Commit Date" dataField="CommitDate" visible={false} />
                        <Column dataType="string" caption="Company ID" dataField="CompanyId" visible={false} />
                        <Column dataType="datetime" caption="Dock - End" dataField="TruckDepartDateTime" visible={false} />
                        <Column dataType="number" caption="Fiscal Period" dataField="FiscalPeriod" visible={false} />
                        <Column dataType="number" caption="Fiscal Year" dataField="FiscalYear" visible={false} />
                        <Column dataType="string" caption="Hold Reason" dataField="HoldReason" visible={false} />
                        <Column dataType="string" caption="Invoice Code" dataField="ConsolidatedInvoice" visible={false} />
                        <Column dataType="datetime" caption="Last Updated" dataField="LastUpdateDateTime" visible={false} />
                        <Column dataType="string" caption="Last Updated By" dataField="LastUpdateUserId" visible={false} />
                        <Column dataType="datetime" caption="Load By" dataField="LoadByPlanDate" visible={false} />
                        <Column dataType="string" caption="Module" dataField="Module" visible={false} />
                        <Column dataType="string" caption="Pick Status" dataField="PickStatus" visible={false} />
                        <Column dataType="string" caption="Plan Location" dataField="PlanLocation" visible={false} />
                        <Column dataType="string" caption="Print Manifest" dataField="PrintSerialNumberManifest" visible={false} />
                        <Column dataType="string" caption="Print Pick Slip" dataField="PrintPickingSlip" visible={false} />
                        <Column dataType="string" caption="Print Put Away" dataField="PrintReceiptPutAway" visible={false} />
                        <Column dataType="datetime" caption="Pick By" dataField="PickByPlanDate" visible={false} />
                        <Column dataType="string" caption="R_LOADBY" dataField="RLoadBy" visible={false} />
                        <Column dataType="string" caption="R_PICKBY" dataField="RPickBy" visible={false} />
                        <Column dataType="string" caption="Record Type" dataField="RecordType" visible={false} />
                        <Column dataType="datetime" caption="Recv/Ship Dt" dataField="ActualReceivedShippedDateTime" visible={false} />
                        <Column dataType="string" caption="Stage" dataField="Stage" visible={false} />
                        <Column dataType="string" caption="Staging Area" dataField="StagingAreaCode" visible={false} />
                        <Column dataType="string" caption="Staging Warehouse" dataField="StagingWareHouse" visible={false} />
                        <Column dataType="string" caption="Third Party Bill Type" dataField="ThirdPartyBillType" visible={false} />
                        <Column dataType="string" caption="To Dispatch" dataField="TransferToDispatch" visible={false} />
                        <Column dataType="string" caption="Trans Carrier" dataField="TransportCarrierId" visible={false} />
                        <Column dataType="string" caption="Trans Carrier Name" dataField="TransportCarrierName" visible={false} />
                        <Column dataType="string" caption="Truck Reference" dataField="TruckReference" visible={false} />
                        <Column dataType="string" caption="Comment" dataField="Comment" visible={false} />

                        {/* User Defined Codes */}
                        <Column dataType="string" caption="Code 1" dataField="UserDefinedCode1" visible={false} />
                        <Column dataType="string" caption="Code 2" dataField="UserDefinedCode2" visible={false} />
                        <Column dataType="string" caption="Code 3" dataField="UserDefinedCode3" visible={false} />
                        <Column dataType="string" caption="Code 4" dataField="UserDefinedCode4" visible={false} />
                        <Column dataType="string" caption="Code 5" dataField="UserDefinedCode5" visible={false} />
                        <Column dataType="string" caption="Code 6" dataField="UserDefinedCode6" visible={false} />
                        <Column dataType="string" caption="Code 7" dataField="UserDefinedCode7" visible={false} />
                        <Column dataType="string" caption="Code 8" dataField="UserDefinedCode8" visible={false} />
                        <Column dataType="string" caption="Code 9" dataField="UserDefinedCode9" visible={false} />
                        <Column dataType="string" caption="Code 10" dataField="UserDefinedCode10" visible={false} />

                        {/* User Defined Dates */}
                        <Column dataType="datetime" caption="Date 1" dataField="UserDefinedDate1" visible={false} />
                        <Column dataType="datetime" caption="Date 2" dataField="UserDefinedDate2" visible={false} />
                        <Column dataType="datetime" caption="Date 3" dataField="UserDefinedDate3" visible={false} />
                        <Column dataType="datetime" caption="Date 4" dataField="UserDefinedDate4" visible={false} />
                        <Column dataType="datetime" caption="Date 5" dataField="UserDefinedDate5" visible={false} />
                        <Column dataType="datetime" caption="Date 6" dataField="UserDefinedDate6" visible={false} />
                        <Column dataType="datetime" caption="Date 7" dataField="UserDefinedDate7" visible={false} />
                        <Column dataType="datetime" caption="Date 8" dataField="UserDefinedDate8" visible={false} />
                        <Column dataType="datetime" caption="Date 9" dataField="UserDefinedDate9" visible={false} />
                        <Column dataType="datetime" caption="Date 10" dataField="UserDefinedDate10" visible={false} />

                        {/* User Defined Quantities */}
                        <Column dataType="number" caption="Quantity 1" dataField="UserDefinedQuantity1" visible={false} />
                        <Column dataType="number" caption="Quantity 2" dataField="UserDefinedQuantity2" visible={false} />
                        <Column dataType="number" caption="Quantity 3" dataField="UserDefinedQuantity3" visible={false} />
                        <Column dataType="number" caption="Quantity 4" dataField="UserDefinedQuantity4" visible={false} />
                        <Column dataType="number" caption="Quantity 5" dataField="UserDefinedQuantity5" visible={false} />
                        <Column dataType="number" caption="Quantity 6" dataField="UserDefinedQuantity6" visible={false} />
                        <Column dataType="number" caption="Quantity 7" dataField="UserDefinedQuantity7" visible={false} />
                        <Column dataType="number" caption="Quantity 8" dataField="UserDefinedQuantity8" visible={false} />
                        <Column dataType="number" caption="Quantity 9" dataField="UserDefinedQuantity9" visible={false} />
                        <Column dataType="number" caption="Quantity 10" dataField="UserDefinedQuantity10" visible={false} />

                        {/* User Defined References */}
                        <Column dataType="string" caption="Reference 1" dataField="UserDefinedReference1" visible={false} />
                        <Column dataType="string" caption="Reference 2" dataField="UserDefinedReference2" visible={false} />
                        <Column dataType="string" caption="Reference 3" dataField="UserDefinedReference3" visible={false} />
                        <Column dataType="string" caption="Reference 4" dataField="UserDefinedReference4" visible={false} />
                        <Column dataType="string" caption="Reference 5" dataField="UserDefinedReference5" visible={false} />
                        <Column dataType="string" caption="Reference 6" dataField="UserDefinedReference6" visible={false} />
                        <Column dataType="string" caption="Reference 7" dataField="UserDefinedReference7" visible={false} />
                        <Column dataType="string" caption="Reference 8" dataField="UserDefinedReference8" visible={false} />
                        <Column dataType="string" caption="Reference 9" dataField="UserDefinedReference9" visible={false} />
                        <Column dataType="string" caption="Reference 10" dataField="UserDefinedReference10" visible={false} />

                        {/* Attachment Count */}
                        <Column dataType="number" caption="Attachment Count" dataField="AttachmentCount" visible={false} />
                    </DataGrid>
                </div>
            </div>
            <SignatureCapture
                visible={showSignatureCapturePopup}
                onClose={() => setShowSignatureCapturePopup(false)}
                transactionHeaderRowId={signatureRowId}
                accessToken={accessToken}
                onSuccess={() => {
                    notify({
                        message: 'Signature saved successfully.',
                        width: 300,
                    }, 'success', 3000);
                    const inst = dataGrid.current && dataGrid.current.instance();
                    if (inst) inst.refresh();
                }}
            />
            <ShowSignature
                visible={showSignaturePopup}
                onClose={() => setShowSignaturePopup(false)}
                transactionHeaderRowId={signatureRowId}
                accessToken={accessToken}
            />
        </div>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(List);
